import { useQuery } from '@tanstack/react-query';

import { queryClient } from '../components/queryClient';
import { FleetService } from '../services';
import { useHasAccess } from '../hooks/useHasAccess';
import { useFleet, useHasPermission } from '../hooks';

export const useFleetsQuery = () => {
  const hasPermission = useHasPermission('fleets:read:list');
  const hasAccess = useHasAccess() && hasPermission;
  const queryKey = ['fleets-key'];

  const queryFn = () => FleetService.getAll();

  return useQuery({
    queryKey,
    queryFn,
    enabled: hasAccess,
  });
};

export const forceRefreshFleets = () => {
  queryClient.invalidateQueries(['fleets-key']);
};

export const useLicensePlateTypes = (enabled: boolean) => {
  const fleet = useFleet();
  const queryKey = ['licensePlateTypes'];

  const queryFn = () => FleetService.getLicensePlateTypes(fleet.uuid);

  return useQuery({
    queryKey,
    queryFn,
    enabled,
    cacheTime: 24 * 60 * 60 * 1000, // 24 hours
    staleTime: 24 * 60 * 60 * 1000, // 24 hours
  });
};
